import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img1 from "../../../images/landing-digital/swift.png";
import Img2 from "../../../images/landing-digital/instant.png";
import Img3 from "../../../images/landing-digital/future-proof.png";
import Img4 from "../../../images/landing-digital/adaptive.png";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Expect(props) {
    return (
        <div className="expect p-100">
        <Container>
            <Row>
                <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
                    <h2><span class="orange">What </span>to Expect</h2>
                </Col>
            </Row>
            <Row className="expect-top">
                {/*<Col xs={12} md={6} lg={6} xl={3} xxl={3}>*/}
                    {/*<div className="expect-box">*/}
                        {/*<div className="expect-img">*/}
                            {/*<LazyLoadImage*/}
                                {/*src={Img1}*/}
                                {/*effect="blur" alt="unlock" className="img-fluid"*/}
                            {/*/>*/}
                        {/*</div>*/}
                        {/*<div className="expect-content">*/}
                            {/*<h5>Swift Results Through Agile Thinking</h5>*/}
                            {/*<p>Resuscitate stuck projects with agile digital strategies. Accelerate completion of priorities for swift outcomes and business development.</p>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</Col>*/}
                {/*<Col xs={12} md={6} lg={6} xl={3} xxl={3}>*/}
                    {/*<div className="expect-box">*/}
                        {/*<div className="expect-img">*/}
                            {/*<LazyLoadImage*/}
                                {/*src={Img2}*/}
                                {/*effect="blur" alt="unlock" className="img-fluid"*/}
                            {/*/>*/}
                        {/*</div>*/}
                        {/*<div className="expect-content">*/}
                            {/*<h5>Instant Progress via Strategic Steps</h5>*/}
                            {/*<p>Embark on your digital future journey today. Grow through logical classifications of distinct projects, guaranteeing bearable success.</p>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</Col>*/}
                {/*<Col xs={12} md={6} lg={6} xl={3} xxl={3}>*/}
                    {/*<div className="expect-box">*/}
                        {/*<div className="expect-img">*/}
                            {/*<LazyLoadImage*/}
                                {/*src={Img3}*/}
                                {/*effect="blur" alt="unlock" className="img-fluid"*/}
                            {/*/>*/}
                        {/*</div>*/}
                        {/*<div className="expect-content">*/}
                            {/*<h5>Future-Proof with Radar 360</h5>*/}
                            {/*<p>Anticipate industry trends 5, 10, 15 years in advance. Develop winning policies for continued leadership and competition.</p>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</Col>*/}
                {/*<Col xs={12} md={6} lg={6} xl={3} xxl={3}>*/}
                    {/*<div className="expect-box">*/}
                        {/*<div className="expect-img">*/}
                            {/*<LazyLoadImage*/}
                                {/*src={Img4}*/}
                                {/*effect="blur" alt="unlock" className="img-fluid"*/}
                            {/*/>*/}
                        {/*</div>*/}
                        {/*<div className="expect-content">*/}
                            {/*<h5>Adaptive Drive for Success</h5>*/}
                            {/*<p>Steer change with agility. Move flawlessly from one stepping stone to the next, preserving drive, momentum and achieving brilliance.</p>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</Col>*/}
                <div className="expect-all">
                    <div className="expect-box">
                    <div className="expect-img">
                    <LazyLoadImage
                    src={Img1}
                    effect="blur" alt="unlock" className="img-fluid"
                    />
                    </div>
                    <div className="expect-content">
                    <h5>Swift Results Through Agile Thinking</h5>
                    <p>Resuscitate stuck projects with agile digital strategies. Accelerate completion of priorities for swift outcomes and business development.</p>
                    </div>
                    </div>
                    <div className="expect-box">
                    <div className="expect-img">
                    <LazyLoadImage
                    src={Img2}
                    effect="blur" alt="unlock" className="img-fluid"
                    />
                    </div>
                    <div className="expect-content">
                    <h5>Instant Progress via Strategic Steps</h5>
                    <p>Embark on your digital future journey today. Grow through logical classifications of distinct projects, guaranteeing bearable success.</p>
                    </div>
                    </div>
                    <div className="expect-box">
                    <div className="expect-img">
                    <LazyLoadImage
                    src={Img3}
                    effect="blur" alt="unlock" className="img-fluid"
                    />
                    </div>
                    <div className="expect-content">
                    <h5>Future-Proof with Radar 360</h5>
                    <p>Anticipate industry trends 5, 10, 15 years in advance. Develop winning policies for continued leadership and competition.</p>
                    </div>
                    </div>
                    <div className="expect-box">
                    <div className="expect-img">
                    <LazyLoadImage
                    src={Img4}
                    effect="blur" alt="unlock" className="img-fluid"
                    />
                    </div>
                    <div className="expect-content">
                    <h5>Adaptive Drive for Success</h5>
                    <p>Steer change with agility. Move flawlessly from one stepping stone to the next, preserving drive, momentum and achieving brilliance.</p>
                    </div>
                    </div>
                </div>
            </Row>
        </Container>
        </div>
    );
}

export default Expect;